import React from 'react';
import PropTypes from 'prop-types';

import BlockContent from '@sanity/block-content-to-react';

import ingredientSerializers from '../../utils/ingredientSerializers';

const Ingredients = ({ ingredients }) => {
    return (
        <div className="recipe__ingredients">
            <h2 className="u-tertiary-title">
                Ingredients
            </h2>

            <BlockContent blocks={ingredients} serializers={ingredientSerializers} />
        </div>
    );
};

export default Ingredients;

Ingredients.propTypes = {
    ingredients: PropTypes.array,
};
